import React, { Component } from 'react';
import { connect } from "react-redux";
import Dropdown from 'react-dropdown'
import {updateParameter} from 'operations/actions.js';
import {WAVEFORMS} from 'constants/waveforms.js';

class WaveformDropdown extends Component {

    constructor(props) {
        super(props);

        this.state = {};

        this.options = [... OSCILLATOR_OPTIONS];
        for (let waveform of WAVEFORMS) {
            this.options.push({
                label: waveform,
                value: waveform
            });
        }
        this.options.push({
            label: "Custom",
            value: "custom",
        });
    }

    getOscillatorOption(value) {
        return this.options.find(
            osc => osc.value === value);
    }

    getSelectedOscillatorType() {
        return this.props.oscillator.customOscillatorType ||
            this.props.oscillator.oscillatorType;
    }

    onSelectOscillatorType(o) {
        let value = o.value === 'none' ? undefined : o.value;
        let parameter = this.props.oscillator.oscillatorTypeParameter;
        if (WAVEFORMS.indexOf(value) > -1) {
            parameter = this.props.oscillator.customOscillatorTypeParameter;
        }
        if (value === "custom") {
            this.props.oscillator.oscillatorType = "custom";
        } else { 
            this.props.sequencerEngine.operationManager.dispatch(
                updateParameter(
                    parameter,
                    value,
                    true));
        }
        this.setState(this.state);
    }

    render() {
       return (
            <div>
              <div className="osc-type-dropdown-container">
                <Dropdown
                  className='osc-type-dropdown'
                  controlClassName='osc-type-control-dropdown'
                  arrowClassName='osc-type-arrow-dropdown'
                  options={this.options}
                  onChange={(o) => this.onSelectOscillatorType(o)}
                  value={ this.getOscillatorOption(this.getSelectedOscillatorType())}
                  placeholder="Osc. Type" />
              </div>
            </div>
        );
    }
}

const OSCILLATOR_OPTIONS = [
    {value: 'square', label:'Square'},
    {value: 'sine', label:'Sine'},
    {value: 'triangle', label:'Triangle'},
    {value: 'sawtooth', label:'Sawtooth'},
    {value: 'pwm', label:'PWM'},
    {value: 'pulse', label:'Pulse'},
    {value: 'fatsquare', label:'Fat Square'},
    {value: 'fatsine', label:'Fat Sine'},
    {value: 'fattriangle', label:'Fat Triangle'},
    {value: 'fatsawtooth', label:'Fat Sawtooth'},
    {value: 'fmsquare', label:'FM Square'},
    {value: 'fmsine', label:'FM Sine'},
    {value: 'fmtriangle', label:'FM Triangle'},
    {value: 'fmsawtooth', label:'FM Sawtooth'},
];

const mapStateToProps = (state, props) => {
    return {
        type: props.oscillator.oscillatorType,
        customType: props.oscillator.customOscillatorType
    };
};

export default connect(mapStateToProps, null)(WaveformDropdown);

